import { getElementId } from 'whisper-base';
import { NudgeTypes } from '../constants';
export const Definition = {
  selector: '[data-coaching-tips-button]',
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    const nudgeId = getElementId(element);
    return Object.assign({
      type: NudgeTypes.COACHING_TIP_PULSER,
      title: 'Coaching Tip'
    }, nudgeId ? {
      id: nudgeId
    } : {});
  }
};